import { render, staticRenderFns } from "./StandingsTopPage.vue?vue&type=template&id=d832bba4"
import script from "./StandingsTopPage.vue?vue&type=script&lang=ts"
export * from "./StandingsTopPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports